// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavBar-cls1_7o7","cls2":"ImpactNavBar-cls2_ORY ImpactNavBar-cls1_7o7"};